var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "video-preview bgi-basic",
      class: { "cursor-pointer": _vm.video },
      on: {
        click: function($event) {
          return _vm.showModal()
        }
      }
    },
    [
      _c("img", { staticClass: "img-basic", attrs: { src: _vm.image } }),
      _vm.video
        ? _c("div", { staticClass: "video-button position_absolute" }, [
            _c("div", { staticClass: "color_white fs_xl mdi mdi-play" })
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f99b6c9a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f99b6c9a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/VideoBlock/VideoBlock.vue
// module id = 40
// module chunks = 0